import { z } from '@faceup/validation'

export const memberSchema = z.object({
  id: z.uuidv7(),
  name: z.string().nullable(),
  email: z.email().nullable(),
  profileImageUrl: z.url().nullable(),
})
